export const PIPELINE_SCOPE = 'INTEGRATION_SCOPE_PUBLIC';

export const CONTROL_API_VERSION = `/v1.1`;

export const PATH = {
  DeliverEvent: `${CONTROL_API_VERSION}/test/deliver_event`,
  EventTraces: `${CONTROL_API_VERSION}/event_traces`,
  EventValues: `${CONTROL_API_VERSION}/event_values`,
  GeneratedEventSchemas: `${CONTROL_API_VERSION}/generated_event_schemas`,
  GeneratedEventSchemasDetails: `${CONTROL_API_VERSION}/generated_event_schemas/details`,
  GeneratedEventSchemasSummary: `${CONTROL_API_VERSION}/generated_event_schemas/summary`,
  Pipeline: `${CONTROL_API_VERSION}/pipeline`,
  PipelineDiff: `${CONTROL_API_VERSION}/pipeline/diff`,
  PipelineSchemaLibrary: `${CONTROL_API_VERSION}/schema_library`,
  PipelineSchemaViolations: `${CONTROL_API_VERSION}/event_schemas/violations/pipeline`,
  PipelineSchemaViolationsDetails: `${CONTROL_API_VERSION}/event_schemas/violations/pipeline/event`,
  PipelineSchemaViolationsDetailsEvents: `${CONTROL_API_VERSION}/event_schemas/violations/pipeline/events`,
  Secret: `${CONTROL_API_VERSION}/secret`,
  SecretClone: `${CONTROL_API_VERSION}/secret/clone`,
  TransformEventWithPlaybook: `${CONTROL_API_VERSION}/test/transform_event_with_playbook`,
  ValidateEvent: `${CONTROL_API_VERSION}/test/validate_event`,
  ValidateIntegration: `${CONTROL_API_VERSION}/test/validate_integration`,
  CreateAJSFile: `${CONTROL_API_VERSION}/analytics_js_file`,
  LuaModules: `${CONTROL_API_VERSION}/lua_modules`,
  Integrations: `${CONTROL_API_VERSION}/integrations`,
};

export const METHOD = {
  DELETE: 'DELETE',
  GET: 'GET',
  POST: 'POST',
  UPDATE: 'UPDATE',
};
